import { create } from "zustand";
import { User } from "@/types";

type StateType = {
	user: User;
	setUser: (payload: User) => void;
};

// 認証状態を監視する
export const userStore = create<StateType>((set) => ({
	user: { id: "", email: "" },
	setUser: (payload) =>
		set((state) => ({
			user: { ...state.user, ...payload },
		})),
}));
